import { render, staticRenderFns } from "./recommendedEnterprise.vue?vue&type=template&id=5b723819&scoped=true&"
import script from "./recommendedEnterprise.vue?vue&type=script&lang=js&"
export * from "./recommendedEnterprise.vue?vue&type=script&lang=js&"
import style0 from "./recommendedEnterprise.vue?vue&type=style&index=0&id=5b723819&lang=less&scoped=true&"
import style1 from "./recommendedEnterprise.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b723819",
  null
  
)

export default component.exports